// Add your custom JS here.
import Alpine from 'alpinejs';
import { CountUp } from 'countup.js'
import intersect from '@alpinejs/intersect';
import Swiper from 'swiper/bundle';
import { Navigation, Pagination, EffectFade, Autoplay } from 'swiper/modules';
import anime from 'animejs/lib/anime.es.js';

Alpine.plugin(intersect);

// ========================================
// Initialize all components
// ========================================
document.addEventListener('DOMContentLoaded', function () {

});

// ========================================
// Alpine Components
// ========================================
document.addEventListener('alpine:init', () => {
    Alpine.data('bsCollapse', () => ({
        ready: false,
        init() { this.$nextTick(() => (this.ready = true)); },

        // Trova tutti i collapse gestiti in questo "accordion scope"
        getAllPanels() {
            // scope = l'elemento che ha x-data="bsCollapse()"
            return Array.from(this.$el.querySelectorAll('.collapse'));
        },

        closeAllExcept(keepEl) {
            this.getAllPanels().forEach((panel) => {
                if (panel === keepEl) return;
                if (panel.classList.contains('show')) this.closePanel(panel);
            });
        },

        openPanel(el) {
            if (!el || el.classList.contains('show') || el.classList.contains('collapsing')) return;

            this.closeAllExcept(el);

            // Trova il trigger e aggiorna subito
            const trigger = this.$el.querySelector(`[data-bs-target="#${el.id}"], [href="#${el.id}"]`);
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'true');
                trigger.classList.add('is-opening');
            }

            el.classList.remove('collapse', 'show');
            el.classList.add('collapsing');

            el.style.height = '0px';
            el.offsetHeight;
            el.style.height = el.scrollHeight + 'px';

            el.addEventListener(
                'transitionend',
                () => {
                    el.classList.remove('collapsing');
                    el.classList.add('collapse', 'show');
                    el.style.height = '';
                    if (trigger) trigger.classList.remove('is-opening');
                },
                { once: true }
            );
        },

        closePanel(el) {
            if (!el || !el.classList.contains('show') || el.classList.contains('collapsing')) return;

            const trigger = this.$el.querySelector(`[data-bs-target="#${el.id}"], [href="#${el.id}"]`);
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
            }

            el.style.height = el.scrollHeight + 'px';
            el.offsetHeight;

            el.classList.remove('collapse', 'show');
            el.classList.add('collapsing');

            el.style.height = '0px';

            el.addEventListener(
                'transitionend',
                () => {
                    el.classList.remove('collapsing');
                    el.classList.add('collapse');
                    el.style.height = '';
                },
                { once: true }
            );
        },

        toggleTarget(selOrEl) {
            const el = this.resolveTarget(selOrEl);
            if (!el) return;

            // Trova il trigger che controlla questo panel
            const trigger = this.$el.querySelector(`[data-bs-target="#${el.id}"], [href="#${el.id}"]`);

            if (el.classList.contains('show')) {
                if (trigger) trigger.setAttribute('aria-expanded', 'false');
                this.closePanel(el);
            } else {
                if (trigger) trigger.setAttribute('aria-expanded', 'true');
                this.openPanel(el);
            }
        },

        resolveTarget(target) {
            if (!target) return null;
            if (target instanceof Element) return target;

            const sel = String(target);
            try {
                return document.querySelector(sel.startsWith('#') ? sel : `#${sel}`);
            } catch (_) {
                return null;
            }
        },
    }));
});

// -----------------------------
// Global trigger wiring
// (outside alpine:init so it's always attached)
// -----------------------------
(function () {
    function closestEl(node, selector, e) {
        let el = node && node.nodeType === 3 ? node.parentElement : node;

        if ((!el || el.nodeType !== 1) && e && typeof e.composedPath === 'function') {
            const path = e.composedPath();
            el = path.find((n) => n && n.nodeType === 1) || null;
        }

        if (el && typeof el.closest === 'function') return el.closest(selector);

        while (el && el.nodeType === 1) {
            if (el.matches && el.matches(selector)) return el;
            el = el.parentElement;
        }
        return null;
    }

    function getTargetSelector(trigger) {
        return (
            trigger.getAttribute('data-bs-target') ||
            (trigger.getAttribute('href')?.startsWith('#') ? trigger.getAttribute('href') : null)
        );
    }

    function getController(trigger) {
        // Alpine must be available and started enough to have closestDataStack
        if (!window.Alpine || typeof window.Alpine.closestDataStack !== 'function') return null;

        const stack = window.Alpine.closestDataStack(trigger) || [];
        for (const data of stack) {
            if (data && typeof data.toggleTarget === 'function') return data;
        }
        return null;
    }

    document.addEventListener('click', (e) => {
        const trigger = closestEl(e.target, '[data-bs-toggle="collapse"]', e);
        if (!trigger) return;

        const sel = getTargetSelector(trigger);
        if (!sel) return;

        // allow new tab / modifiers
        const allowNav = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1;
        if (allowNav) return;

        e.preventDefault();

        const controller = getController(trigger);
        if (!controller) return;

        controller.toggleTarget(sel);

        // ARIA sync (immediata + dopo transizione)
        const target = document.querySelector(sel);
        if (target?.id) trigger.setAttribute('aria-controls', target.id);
        trigger.setAttribute('aria-expanded', target?.classList.contains('show') ? 'true' : 'false');

        if (target) {
            target.addEventListener(
                'transitionend',
                () => {
                    trigger.setAttribute('aria-expanded', target.classList.contains('show') ? 'true' : 'false');
                },
                { once: true }
            );
        }
    });
})();

Alpine.data('mainHeader', () => ({
    lastScroll: 0,
    ticking: false,
    fullPreHeight: 0,
    shrink: false,
    initialized: false,

    init() {
        this.$nextTick(() => {
            // Salva altezza naturale
            this.fullPreHeight = this.$refs.preHeader.offsetHeight;

            // Imposta height inline SOLO dopo mount
            this.$refs.preHeader.style.height = this.fullPreHeight + 'px';

            // Posiziona il TOC alla posizione iniziale
            const toc = document.querySelector('.toc-scrollspy');
            const nav = this.$el.querySelector('.navbar-container');
            if (toc && nav) toc.style.top = nav.getBoundingClientRect().bottom + 'px';

            this.initialized = true;
        });

        window.addEventListener('resize', () => {
            if (!this.initialized) return;

            this.fullPreHeight = this.$refs.preHeader.scrollHeight;
            if (!this.shrink) {
                this.$refs.preHeader.style.height = this.fullPreHeight + 'px';
            }
        });
    },

    handleScroll() {
        if (!this.initialized) return;

        if (!this.ticking) {
            requestAnimationFrame(() => {
                this.update();
                this.ticking = false;
            });
            this.ticking = true;
        }
    },

    update() {
        const current = window.scrollY;

        if (Math.abs(current - this.lastScroll) < 4) return;

        if (current > this.lastScroll && current > 80) {
            this.hidePreHeader();
            this.shrink = true;
        } else {
            this.showPreHeader();
            this.shrink = false;
        }

        this.lastScroll = current;
    },

    // Legge il bottom reale del navbar ogni frame e aggiorna il TOC inline,
    // così segue tutte le transizioni in corso (pre-header + brand height + padding)
    _startTocSync(duration = 420) {
        const toc   = document.querySelector('.toc-scrollspy');
        const nav   = this.$el.querySelector('.navbar-container');
        if (!toc || !nav) return;

        const start = performance.now();
        const tick  = (now) => {
            toc.style.top = nav.getBoundingClientRect().bottom + 'px';
            if (now - start < duration) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
    },

    hidePreHeader() {
        this.$refs.preHeader.style.height = '0px';
        this._startTocSync();
    },

    showPreHeader() {
        this.$refs.preHeader.style.height = this.fullPreHeight + 'px';
        this._startTocSync();
    }
}));

// ========================================
// Alpine Navbar Component
// ========================================
Alpine.data('mainNav', () => ({
    mobileMenuOpen: false,
    ready: false,

    init() {
        this.$nextTick(() => this.ready = true);
    },

    toggleMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    },

    closeMenu() {
        this.mobileMenuOpen = false;
    },

    handleEffect() {
        if (!this.ready) return;

        if (this.mobileMenuOpen) {
            this.openPanel(this.$refs.navCollapse);
        } else {
            this.closePanel(this.$refs.navCollapse);
        }
    },

    openPanel(el) {
        if (!el || el.classList.contains('show') || el.classList.contains('collapsing')) return;

        el.classList.remove('collapse', 'show');
        el.classList.add('collapsing');

        el.style.height = '0px';
        el.offsetHeight; // force reflow
        el.style.height = el.scrollHeight + 'px';

        el.addEventListener('transitionend', () => {
            el.classList.remove('collapsing');
            el.classList.add('collapse', 'show');
            el.style.height = '';
            document.body.classList.add('nav-open');
        }, { once: true });
    },

    closePanel(el) {
        if (!el || !el.classList.contains('show') || el.classList.contains('collapsing')) return;

        el.style.height = el.scrollHeight + 'px';
        el.offsetHeight; // force reflow

        el.classList.remove('collapse', 'show');
        el.classList.add('collapsing');

        el.style.height = '0px';

        el.addEventListener('transitionend', () => {
            el.classList.remove('collapsing');
            el.classList.add('collapse');
            el.style.height = '';
            document.body.classList.remove('nav-open');
        }, { once: true });
    }
}));

// ========================================
// Alpine Offcanvas Manager (offcanvas-top hover desktop + tap mobile)
// ========================================
Alpine.data('offcanvasManager', () => ({
    activeOffcanvas: null,
    activeTrigger: null,
    backdrop: null,
    isTransitioning: false,
    mobileSubmenu: null,

    transitionDuration: 300,
    hoverOpenDelay: 80,
    hoverCloseDelay: 220,
    _openTimer: null,
    _closeTimer: null,

    init() {
        // Desktop hover (con cattura per delega)
        document.addEventListener('pointerenter', (e) => this.onPointerEnter(e), true);
        document.addEventListener('pointerleave', (e) => this.onPointerLeave(e), true);

        // Mobile/touch click toggle
        document.addEventListener('click', (e) => this.onClick(e));

        // ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                if (this.mobileSubmenu) this.closeMobileSubmenu();
                else this.close();
            }
        });

        // Back button for mobile submenu
        document.getElementById('offcanvas-mobile-back')?.addEventListener('click', () => {
            this.closeMobileSubmenu();
        });
    },

    // Hover "vero" solo su dispositivi con mouse/trackpad
    isHoverMode() {
        return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    },

    // Trova trigger + id offcanvas dal click/hover (safe su TextNode / pointer events)
    getInfoFromTriggerEvent(e) {
        // helper locale: closest "safe"
        const closestEl = (node, selector) => {
            let el = node;

            // Text node -> parent element
            if (el && el.nodeType === 3) el = el.parentElement;

            // Se non è un Element, prova a risalire dal composedPath (utile su pointer events / shadow DOM)
            if ((!el || el.nodeType !== 1) && e && typeof e.composedPath === 'function') {
                const path = e.composedPath();
                el = path.find(n => n && n.nodeType === 1) || null;
            }

            // closest nativo
            if (el && typeof el.closest === 'function') return el.closest(selector);

            // fallback manuale
            while (el && el.nodeType === 1) {
                if (el.matches && el.matches(selector)) return el;
                el = el.parentElement;
            }

            return null;
        };

        const trigger = closestEl(e.target, '[class*="show-offcanvas-"]');
        if (!trigger) return null;

        const classMatch = [...trigger.classList].find(c => c.startsWith('show-offcanvas-'));
        if (!classMatch) return null;

        const id = classMatch.replace('show-', '');
        const el = document.getElementById(id);
        if (!el) return null;

        return { trigger, id, el };
    },

    isInsideActiveOffcanvas(node) {
        return !!(this.activeOffcanvas && node && this.activeOffcanvas.contains(node));
    },

    isInsideActiveTrigger(node) {
        return !!(this.activeTrigger && node && this.activeTrigger.contains(node));
    },

    onPointerEnter(e) {
        if (!this.isHoverMode() || this.isMobileBreakpoint()) return;

        // Se entro nel trigger o nella offcanvas (o in un suo figlio) annullo la chiusura pending
        if (this.getInfoFromTriggerEvent(e) || this.isInsideActiveOffcanvas(e.target)) {
            clearTimeout(this._closeTimer);
        }

        const info = this.getInfoFromTriggerEvent(e);
        if (!info) return;

        clearTimeout(this._openTimer);
        this._openTimer = setTimeout(() => {
            if (this.isTransitioning) return;

            // già aperta quella
            if (this.activeOffcanvas === info.el) return;

            // se un'altra aperta, chiudi poi apri
            if (this.activeOffcanvas && this.activeOffcanvas !== info.el) {
                this.close(() => this.open(info.id, info.trigger, { hover: true }));
                return;
            }

            this.open(info.id, info.trigger, { hover: true });
        }, this.hoverOpenDelay);
    },

    onPointerLeave(e) {
        if (!this.isHoverMode() || this.isMobileBreakpoint()) return;

        // Se sto lasciando un elemento interno alla offcanvas ma sto ancora andando
        // verso un altro elemento interno, NON devo chiudere.
        if (this.isInsideActiveOffcanvas(e.target)) {
            if (this.isInsideActiveOffcanvas(e.relatedTarget) || this.isInsideActiveTrigger(e.relatedTarget)) {
                return;
            }

            clearTimeout(this._openTimer);
            clearTimeout(this._closeTimer);
            this._closeTimer = setTimeout(() => {
                if (!this.isTransitioning) this.close();
            }, this.hoverCloseDelay);

            return;
        }

        // Se sto lasciando un trigger, chiudo SOLO se non sto entrando nella offcanvas o su trigger stesso
        const info = this.getInfoFromTriggerEvent(e);
        if (!info) return;

        if (this.isInsideActiveOffcanvas(e.relatedTarget) || this.isInsideActiveTrigger(e.relatedTarget)) {
            return;
        }

        clearTimeout(this._openTimer);
        clearTimeout(this._closeTimer);
        this._closeTimer = setTimeout(() => {
            if (!this.isTransitioning) this.close();
        }, this.hoverCloseDelay);
    },

    // ---------------------------
    // MOBILE: CLICK TOGGLE
    // ---------------------------

    isMobileBreakpoint() {
        return window.matchMedia('(max-width: 1199.98px)').matches;
    },

    onClick(e) {
        const info = this.getInfoFromTriggerEvent(e);
        if (!info) return;

        // Sotto i 1200px (hamburger visibile): usa sempre l'offcanvas laterale,
        // indipendentemente dal fatto che il device abbia hover o meno
        if (this.isMobileBreakpoint()) {
            e.preventDefault();
            if (this.isTransitioning) return;
            this.openMobileSubmenu(info);
            return;
        }

        // Desktop (>= 1200px) con hover: apertura gestita dal hover, non dal click
        if (this.isHoverMode()) return;

        // Touch + schermo large (edge case): comportamento originale
        const link = e.target.closest('a[href]');
        if (link) return;

        e.preventDefault();
        if (this.isTransitioning) return;

        if (this.activeOffcanvas === info.el) {
            this.close();
            return;
        }

        if (this.activeOffcanvas && this.activeOffcanvas !== info.el) {
            this.close(() => this.open(info.id, info.trigger));
            return;
        }

        this.open(info.id, info.trigger);
    },

    // ---------------------------
    // MOBILE SUBMENU (offcanvas-end)
    // ---------------------------

    openMobileSubmenu(info) {
        const sideEl = document.getElementById('offcanvas-mobile-submenu');
        if (!sideEl) return;

        // Popola il titolo dal testo del link di navigazione
        const titleEl = document.getElementById('offcanvas-mobile-title');
        if (titleEl) {
            const triggerLink = info.trigger.querySelector('a');
            titleEl.textContent = (triggerLink ? triggerLink.textContent : info.trigger.textContent).trim();
            titleEl.href = triggerLink ? triggerLink.href : '#';
        }

        // Copia il contenuto dall'offcanvas-top corrispondente (senza duplicare HTML nel server)
        const sourceBody = info.el.querySelector('.offcanvas-body');
        const targetBody = document.getElementById('offcanvas-mobile-body');
        if (sourceBody && targetBody) {
            targetBody.innerHTML = sourceBody.innerHTML;
        }

        // Apri (stessa sequenza showing/show degli altri offcanvas)
        this.isTransitioning = true;
        this.mobileSubmenu = sideEl;

        sideEl.classList.add('showing');
        sideEl.style.visibility = 'visible';
        void sideEl.offsetWidth; // force reflow
        sideEl.classList.add('show');
        sideEl.classList.remove('showing');

        setTimeout(() => { this.isTransitioning = false; }, this.transitionDuration);
    },

    closeMobileSubmenu(callback = null) {
        if (!this.mobileSubmenu || this.isTransitioning) return;

        this.isTransitioning = true;
        const el = this.mobileSubmenu;

        el.classList.add('hiding');
        el.classList.remove('show');

        let closed = false;
        const cleanup = () => {
            if (closed) return;
            closed = true;
            el.classList.remove('hiding');
            el.style.visibility = '';
            this.mobileSubmenu = null;
            this.isTransitioning = false;
            if (callback) callback();
        };

        el.addEventListener('transitionend', cleanup, { once: true });
        setTimeout(cleanup, this.transitionDuration + 50);
    },

    // ---------------------------
    // CORE: OPEN / CLOSE
    // ---------------------------
    open(id, trigger = null, opts = {}) {
        if (this.isTransitioning) return;

        const el = document.getElementById(id);
        if (!el) return;

        this.isTransitioning = true;
        this.activeOffcanvas = el;

        // active sul trigger
        if (this.activeTrigger) this.activeTrigger.classList.remove('active');
        this.activeTrigger = trigger;
        if (this.activeTrigger) this.activeTrigger.classList.add('active');

        document.body.classList.add('offcanvas-open');

        el.classList.add('showing');
        el.style.visibility = 'visible';
        void el.offsetWidth;
        el.classList.add('show');
        el.classList.remove('showing');

        // Desktop hover: niente backdrop e niente scroll-lock (mega-menu)
        // Mobile: sì backdrop + overflow hidden
        if (this.isHoverMode() && opts.hover) {
            this.removeBackdrop();
            document.body.classList.remove('overflow-hidden');
        } else {
            this.createBackdrop();
            document.body.classList.add('overflow-hidden');
        }


        setTimeout(() => { this.isTransitioning = false; }, this.transitionDuration);
    },

    close(callback = null) {
        if (!this.activeOffcanvas || this.isTransitioning) return;

        this.isTransitioning = true;

        const el = this.activeOffcanvas;
        el.classList.add('hiding');
        el.classList.remove('show');

        let closed = false;

        const cleanup = () => {
            if (closed) return;
            closed = true;

            el.classList.remove('hiding');
            el.style.visibility = '';

            if (this.activeTrigger) {
                this.activeTrigger.classList.remove('active');
                this.activeTrigger = null;
            }

            this.activeOffcanvas = null;

            this.removeBackdrop();
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('offcanvas-open');

            this.isTransitioning = false;

            if (callback) callback();
        };

        el.addEventListener('transitionend', cleanup, { once: true });
        setTimeout(cleanup, this.transitionDuration);
    },

    createBackdrop() {
        if (this.backdrop) return;

        this.backdrop = document.createElement('div');
        this.backdrop.className = 'offcanvas-backdrop fade show';
        this.backdrop.addEventListener('click', () => this.close());
        document.body.appendChild(this.backdrop);
    },

    removeBackdrop() {
        if (!this.backdrop) return;
        this.backdrop.remove();
        this.backdrop = null;
    }
}));

// ========================================
// Alpine Scrollspy TOC
// ========================================
Alpine.data('scrollspy', () => ({
    _observer: null,
    _resizeObserver: null,

    init() {
        this.$nextTick(() => {
            const nav    = this.$el.querySelector('.toc-scrollspy');
            const list   = nav?.querySelector('ul');
            const select = nav?.querySelector('.toc-compact-select');
            if (!nav || !list) return;

            const targets = this.$el.querySelectorAll('[data-toc]');
            if (!targets.length) return;

            targets.forEach((el, i) => {
                if (!el.id) el.id = 'toc-section-' + i;

                // Full list link
                const li = document.createElement('li');
                const a  = document.createElement('a');
                a.href = '#' + el.id;
                a.textContent = el.getAttribute('data-toc');
                a.dataset.tocTarget = el.id;
                a.addEventListener('click', (e) => {
                    e.preventDefault();
                    this._scrollTo(el.id);
                });
                li.appendChild(a);
                list.appendChild(li);

                // Compact select option
                if (select) {
                    const opt = document.createElement('option');
                    opt.value = el.id;
                    opt.textContent = el.getAttribute('data-toc');
                    select.appendChild(opt);
                }
            });

            // Navigate on select change
            if (select) {
                select.addEventListener('change', (e) => {
                    if (e.target.value) this._scrollTo(e.target.value);
                });
            }

            // Toggle button (X → collapse, hamburger → expand)
            const toggleBtn = nav.querySelector('.toc-compact-toggle');
            if (toggleBtn) {
                toggleBtn.addEventListener('click', () => {
                    const collapsed = nav.classList.toggle('toc-scrollspy--collapsed');
                    toggleBtn.setAttribute('aria-label', collapsed
                        ? toggleBtn.dataset.labelOpen  || 'Apri indice'
                        : toggleBtn.dataset.labelClose || 'Chiudi indice'
                    );
                });
            }

            nav.classList.add('toc-scrollspy--visible');
            this._setActive(targets[0].id);

            // Cache the intrinsic width of all list items.
            // The ul is display:flex inside a constrained container, so scrollWidth
            // only returns the container width. We force width:max-content momentarily
            // to let the flex row expand to its real content size, then restore.
            list.style.width = 'max-content';
            this._listNaturalWidth = list.offsetWidth;
            list.style.width = '';

            // Detect overflow → switch between full list and compact bar
            this._resizeObserver = new ResizeObserver(() => this._checkOverflow(nav, list));
            this._resizeObserver.observe(nav);
            this._checkOverflow(nav, list);

            this._observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) this._setActive(entry.target.id);
                });
            }, { rootMargin: '-15% 0px -70% 0px' });

            targets.forEach(el => this._observer.observe(el));
        });
    },

    _checkOverflow(nav, list) {
        const container  = list.parentElement;
        // Compare the cached natural width against the available container width.
        // Never read list.scrollWidth here: when --compact hides the ul it returns 0,
        // which would cause an infinite compact ↔ full toggle loop.
        const isOverflow = this._listNaturalWidth > container.clientWidth;
        const wasCompact = nav.classList.contains('toc-scrollspy--compact');

        nav.classList.toggle('toc-scrollspy--compact', isOverflow);

        // Reset collapsed state whenever we switch back to the full list
        if (wasCompact && !isOverflow) {
            nav.classList.remove('toc-scrollspy--collapsed');
        }

        // Classe body: presente solo quando il TOC è in modalità full (non compact)
        document.body.classList.toggle('has-toc', !isOverflow);
    },

    _setActive(id) {
        this.$el.querySelectorAll('.toc-scrollspy a[data-toc-target]').forEach(a => {
            a.classList.toggle('is-active', a.dataset.tocTarget === id);
        });

        // Keep select in sync with the active section
        const select = this.$el.querySelector('.toc-compact-select');
        if (select) select.value = id;
    },

    _scrollTo(id) {
        const el = document.getElementById(id);
        if (!el) return;

        const toc    = document.querySelector('.toc-scrollspy');
        const offset = toc ? parseFloat(toc.style.top || 0) + toc.offsetHeight : 0;
        const top    = el.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({ top, behavior: 'smooth' });
        this._setActive(id);
    },

    destroy() {
        if (this._observer) this._observer.disconnect();
        if (this._resizeObserver) this._resizeObserver.disconnect();
        document.body.classList.remove('has-toc');
    }
}));

// ========================================
// Alpine Card Hover content
// ========================================
Alpine.data('fadeSwap', (hasStats = true) => ({
    hovered: false,
    currentHeight: 0,
    excerptHeight: 0,
    statsHeight: 0,

    init() {
        this.$nextTick(() => {
            this.excerptHeight = this.$refs.excerpt.scrollHeight;
            this.currentHeight = this.excerptHeight;

            if (hasStats && this.$refs.stats) {
                // stats has display:none at this point (set by x-show): override temporarily to measure
                const el = this.$refs.stats;
                const saved = el.style.display;
                el.style.display = 'block';
                this.statsHeight = el.scrollHeight;
                el.style.display = saved;
            }
        });
    },

    mouseenter() {
        if (!hasStats) return;
        this.hovered = true;
        this.currentHeight = this.statsHeight;
    },

    mouseleave() {
        if (!hasStats) return;
        this.hovered = false;
        this.currentHeight = this.excerptHeight;
    }
}));

// ========================================
// Alpine Counter animated
// ========================================
Alpine.data('statsCounter', () => ({
    observer: null,
    started: false,

    init() {
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !this.started) {
                    this.started = true
                    this.animateCounters()
                    this.observer.disconnect()
                }
            })
        }, {
            threshold: 0.35
        })

        this.observer.observe(this.$el)
    },

    animateCounters() {
        const counters = this.$el.querySelectorAll('.js-counter')

        counters.forEach((el) => {
            const raw = el.textContent.trim()
            const parsed = this.parseCounter(raw)

            if (!parsed) return

            el.textContent = parsed.prefix + '0' + parsed.suffix

            const counter = new CountUp(el, parsed.value, {
                duration: 2,
                decimalPlaces: parsed.decimalPlaces,
                separator: '.',
                decimal: ',',
                prefix: parsed.prefix,
                suffix: parsed.suffix
            })

            if (!counter.error) {
                counter.start()
            } else {
                console.error(counter.error)
            }
        })
    },

    parseCounter(raw) {
        if (!raw) return null

        // Cerca la prima parte numerica, anche con decimali usando la virgola
        const match = raw.match(/([^\d+-]*[+-]?)(\d+(?:,\d+)?)(.*)/)

        if (!match) return null

        const prefix = match[1] || ''
        const numericPart = match[2] || ''
        const suffix = match[3] || ''

        const normalized = numericPart.replace(',', '.')
        const value = parseFloat(normalized)

        if (isNaN(value)) return null

        const decimalPlaces = numericPart.includes(',')
            ? numericPart.split(',')[1].length
            : 0

        return {
            prefix,
            suffix,
            value,
            decimalPlaces
        }
    }
}))

// ========================================
// Alpine Swiper Focus slider
// ========================================
Alpine.data('focusSlider', () => ({
    swiper: null,

    init() {
        const slidesCount = this.$refs.slider.querySelectorAll('.swiper-slide').length
        const useLoop = slidesCount >= 5

        this.swiper = new Swiper(this.$refs.slider, {
            modules: [Navigation, Pagination],

            loop: useLoop,
            rewind: !useLoop,

            speed: 700,
            grabCursor: true,
            centeredSlides: true,
            watchOverflow: true,

            slidesPerView: 'auto',
            spaceBetween: 0,

            navigation: {
                prevEl: [this.$refs.prev, this.$refs.paginationPrev],
                nextEl: [this.$refs.next, this.$refs.paginationNext],
            },

            pagination: {
                el: this.$refs.pagination,
                clickable: true,
            },
        })
    },
}))

// ========================================
// Alpine Swiper Tab slider
// ========================================
Alpine.data('focusTabsSlider', () => ({
    swiper: null,
    activeIndex: 0,

    init() {
        this.swiper = new Swiper(this.$refs.slider, {
            modules: [EffectFade, Autoplay, Pagination],

            slidesPerView: 1,
            loop: true,
            speed: 600,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: true,

            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },

            pagination: {
                el: this.$refs.pagination,
                clickable: true,
            },

            on: {
                init: (swiper) => {
                    this.activeIndex = swiper.realIndex
                },
                slideChange: (swiper) => {
                    this.activeIndex = swiper.realIndex
                },
            },
        })
    },

    goTo(index) {
        if (!this.swiper) return
        this.swiper.slideTo(index)
    },
}))

// ========================================
// Alpine Swiper Timeline
// ========================================

// Calcola e aggiorna l'offset del container Bootstrap come CSS custom property
function updateContainerOffset() {
    const container = document.querySelector('[data-container-ref]');
    if (!container) return;
    const offset = container.getBoundingClientRect().left;
    document.documentElement.style.setProperty('--container-offset', `${offset}px`);
}

window.addEventListener('resize', updateContainerOffset);
document.addEventListener('DOMContentLoaded', updateContainerOffset);

Alpine.data('timelineSlider', () => ({
    swiper: null,

    init() {
        updateContainerOffset();

        this.swiper = new Swiper(this.$refs.slider, {
            modules: [Navigation],
            rewind: false,
            speed: 700,
            grabCursor: true,
            watchOverflow: true,
            slidesPerView: 3.2,
            spaceBetween: 0,

            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 0,
                },
                992: {
                    slidesPerView: 3.2,
                    spaceBetween: 0,
                },
            },

            navigation: {
                prevEl: this.$refs.prev,
                nextEl: this.$refs.next,
            },
        });
    },
}));

Alpine.data('reviewsSlider', () => ({
    swiper: null,

    init() {
        updateContainerOffset();

        this.swiper = new Swiper(this.$refs.slider, {
            modules: [Navigation, Pagination],
            rewind: false,
            speed: 700,
            grabCursor: true,
            watchOverflow: true,
            slidesPerView: 3.2,
            spaceBetween: 0,

            navigation: {
                prevEl: [this.$refs.prev, this.$refs.paginationPrev],
                nextEl: [this.$refs.next, this.$refs.paginationNext],
            },

            pagination: {
                el: this.$refs.pagination,
                clickable: true,
            },

            breakpoints: {
                0: {
                    slidesPerView: 1.2,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 0,
                },
                992: {
                    slidesPerView: 3.2,
                    spaceBetween: 0,
                },
            },
        });
    },
}));

Alpine.data('featuredPostSlider', () => ({
    swiper: null,

    init() {
        this.swiper = new Swiper(this.$refs.slider, {
            modules: [Navigation, Pagination],
            rewind: false,
            speed: 700,
            grabCursor: true,
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 20,

            navigation: {
                prevEl: [this.$refs.prev, this.$refs.paginationPrev],
                nextEl: [this.$refs.next, this.$refs.paginationNext],
            },

            pagination: {
                el: this.$refs.pagination,
                clickable: true,
            },
        });
    },
}));

Alpine.data('svgAnim', () => ({
    played: false,

    play() {
        if (this.played) return;
        this.played = true;

        const strokePaths = [...this.$el.querySelectorAll('.sp')];
        const svgStroke   = this.$el.querySelector('.svg-stroke');
        const svgFill     = this.$el.querySelector('.svg-fill');

        const lengths  = strokePaths.map(p => p.getTotalLength());
        const maxLen   = Math.max(...lengths);
        const totalDur = 3200;
        const n        = strokePaths.length;
        const slotDur  = (totalDur * 0.80) / n;
        const crossDur = totalDur * 0.15;

        strokePaths.forEach((p, i) => {
            p.style.strokeDasharray  = lengths[i];
            p.style.strokeDashoffset = lengths[i];
        });
        svgStroke.style.opacity = '1';
        svgFill.style.opacity   = '0';
        svgFill.style.visibility = 'visible';

        const tl = anime.timeline({ easing: 'easeOutQuart' });

        const minDur = slotDur * 0.5; // durata minima garantita per ogni barra
        strokePaths.forEach((sp, i) => {
            const dur = Math.max(minDur, slotDur * (lengths[i] / maxLen));
            tl.add({
                targets: sp,
                strokeDashoffset: [lengths[i], 0],
                duration: dur,
            }, i * slotDur);
        });

        const drawEnd = (n - 1) * slotDur + slotDur * (lengths[n - 1] / maxLen);

        tl.add({ targets: svgStroke, opacity: [1, 0], duration: crossDur, easing: 'easeInQuad'  }, drawEnd);
        tl.add({ targets: svgFill,   opacity: [0, 1], duration: crossDur, easing: 'easeOutQuad' }, drawEnd);
    }
}));

// Start Alpine.js
window.Alpine = Alpine;
Alpine.start();

// ========================================
// Feature Detection
// ========================================
document.documentElement.classList.add(
    'ontouchstart' in window ? 'touchevents' : 'no-touchevents'
);

if (!document.createElement('svg').getAttributeNS) {
    document.documentElement.classList.add('no-svg');
}


